import { CONTACT } from "./constants";

export default function FloatingWhatsApp() {
  return (
    <a
      href={CONTACT.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile iletişime geç"
      data-testid="floating-whatsapp-btn"
      className="ab-pulse-ring fixed bottom-6 right-6 z-50 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[var(--wa-green)] text-white flex items-center justify-center shadow-[0_18px_40px_-12px_rgba(37,211,102,0.55)] hover:scale-110 transition-transform ab-float"
    >
      <svg
        viewBox="0 0 32 32"
        className="w-7 h-7 sm:w-8 sm:h-8"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.79c-.29-.15-1.7-.84-1.96-.93-.26-.1-.46-.15-.65.15s-.75.93-.92 1.12c-.17.2-.34.22-.63.07-.29-.15-1.21-.45-2.31-1.43-.85-.76-1.43-1.7-1.6-1.98-.17-.29-.02-.45.13-.6.13-.13.29-.34.43-.51.14-.17.19-.29.29-.49.1-.2.05-.37-.02-.52-.07-.15-.65-1.57-.9-2.16-.24-.57-.48-.49-.65-.5l-.55-.01c-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.43s1.05 2.82 1.2 3.02c.15.2 2.07 3.16 5.01 4.43.7.3 1.25.48 1.67.62.7.22 1.34.19 1.84.12.56-.08 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.07-.12-.27-.2-.56-.34zM16.03 5.33C10.06 5.33 5.2 10.19 5.2 16.16c0 1.95.51 3.85 1.47 5.51L5.13 27l5.48-1.44c1.61.88 3.42 1.34 5.24 1.34h.01c5.97 0 10.83-4.86 10.83-10.83 0-2.89-1.13-5.61-3.18-7.65a10.74 10.74 0 0 0-7.66-3.19zm6.41 17.24c-.27.76-1.59 1.46-2.21 1.55-.56.08-1.27.12-2.05-.13-.47-.15-1.08-.35-1.85-.69-3.26-1.41-5.39-4.69-5.55-4.91-.16-.21-1.32-1.76-1.32-3.36 0-1.6.84-2.39 1.14-2.71.3-.32.66-.4.88-.4.22 0 .44.01.63.01.2 0 .47-.08.74.56.27.65.93 2.25 1.01 2.42.08.17.13.37.03.59-.1.22-.15.36-.3.55-.15.19-.31.42-.45.56-.15.15-.3.31-.13.6.17.29.75 1.23 1.61 2 .85.77 1.6 1.03 1.84 1.15.24.12.39.1.53-.06.15-.17.61-.71.78-.95.16-.24.33-.2.55-.12.22.08 1.42.67 1.66.79.24.12.4.18.46.28.06.1.06.59-.21 1.35z" />
      </svg>
    </a>
  );
}
